import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
} from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { DownloadIcon, EmailIcon } from '../../../../src/assets/icons/icons';
import { ToolbarSearchInput } from '@components/DataGrid/ToolbarSearchInput';

declare module '@mui/x-data-grid' {
  interface ToolbarPropsOverrides {
    searchText: string;
    onSearchChange: (value: string) => void;
    onEmailInvite: () => void;
    onExport: () => void;
  }
}

interface UsersTableToolbarProps {
  searchText: string;
  onSearchChange: (newValue: string) => void;
  onEmailInvite: () => void;
  onExport: () => void;
};

const UsersTableToolbar = ({
  searchText,
  onSearchChange,
  onEmailInvite,
  onExport
}: UsersTableToolbarProps) => {
  return (
    <GridToolbarContainer
      data-testid='custom-toolbar'
      sx={{ padding: 1, justifyContent: 'flex-start' }}
    >
      <ToolbarSearchInput
        value={searchText}
        onChange={(newValue) => onSearchChange(newValue as unknown as string)}
      />
      <GridToolbarColumnsButton />
      <Button
        size='small'
        startIcon={<EmailIcon />}
        onClick={onEmailInvite}
      >
        Email Invite
      </Button>
      <Button
        size='small'
        startIcon={<DownloadIcon />}
        onClick={onExport}
      >
        Export CSV
      </Button>
    </GridToolbarContainer>
  );
};

export default UsersTableToolbar;
